import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

export const fetchCategories = () => client.get("/categories").then((r) => r.data);
export const fetchCategory = (slug) => client.get(`/categories/${slug}`).then((r) => r.data);

export const fetchTerms = (params = {}) => client.get("/terms", { params }).then((r) => r.data);
export const fetchTerm = (slug) => client.get(`/terms/${slug}`).then((r) => r.data);

export const fetchProducts = (params = {}) => client.get("/products", { params }).then((r) => r.data);
export const fetchProduct = (slug) => client.get(`/products/${slug}`).then((r) => r.data);

export const globalSearch = (q) => client.get("/search", { params: { q } }).then((r) => r.data);
export const fetchFilters = () => client.get("/filters").then((r) => r.data);

export const fetchRoutine = (slug) => client.get(`/terms/${slug}/routine`).then((r) => r.data);

export const fetchWhatsAppStats = () => client.get("/stats/whatsapp").then((r) => r.data);
export const trackWhatsAppClick = () => client.post("/stats/whatsapp-click").then((r) => r.data);

export const regenerateTerm = (slug) =>
  client.post(`/terms/${slug}/regenerate`).then((r) => r.data);

// Trust Score (Badge de Confiance)
export const fetchTrustScore = (slug) => client.get(`/trust/${slug}`).then((r) => r.data);
export const fetchAllTrustScores = () => client.get("/trust").then((r) => r.data);
export const fetchTrustTop = (perSection = 12) =>
  client.get("/trust-top", { params: { per_section: perSection } }).then((r) => r.data);
export const fetchTrustSummary = () => client.get("/trust-summary").then((r) => r.data);
